import React, { useContext } from 'react';
import {
	BottomNavigation,
	BottomNavigationAction,
	Box,
	List,
	Paper,
} from '@mui/material';
import { CheckCircle, Pending, Reorder, Timelapse } from '@mui/icons-material';
import OrdersContext from '../Context/Orders/OrdersContext';
import ListItem from '../Components/OrderListItem/OrderListItem';
import NewOrderDialog from '../Components/NewOrderDialog/NewOrderDialog';
import ToastAlert from '../Components/ToastAlert/ToastAlert';

export default function Orders() {
	const { orders, filterOption, filterOrderNav, onChangeFilterOrderNav } =
		useContext(OrdersContext);
	const FilteredData = () => {
		let data = '';
		switch (filterOrderNav) {
			case 'all':
				switch (filterOption.value) {
					case 'next':
						data = orders
							.filter((order) => order.status !== 'done')
							.sort(
								(a, b) =>
									Date.parse(a.dateOfDelivery) - Date.parse(b.dateOfDelivery)
							)
							.map((order) => <ListItem key={order.id} order={order} />);
						break;
					case 'distant':
						data = orders
							.filter((order) => order.status !== 'done')
							.sort(
								(a, b) =>
									Date.parse(b.dateOfDelivery) - Date.parse(a.dateOfDelivery)
							)
							.map((order) => <ListItem key={order.id} order={order} />);
						break;
					case 'recents':
						data = orders
							.filter((order) => order.status !== 'done')
							.sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
							.map((order) => <ListItem key={order.id} order={order} />);
						break;
					case 'oldest':
						data = orders
							.filter((order) => order.status !== 'done')
							.sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt))
							.map((order) => <ListItem key={order.id} order={order} />);
						break;

					default:
						data = orders
							.filter((order) => order.status !== 'done')
							.map((order) => <ListItem key={order.id} order={order} />);

						break;
				}
				break;

			default:
				switch (filterOption.value) {
					case 'next':
						data = orders
							.filter((order) => order.status === filterOrderNav)
							.sort(
								(a, b) =>
									Date.parse(a.dateOfDelivery) - Date.parse(b.dateOfDelivery)
							)
							.map((order) => <ListItem key={order.id} order={order} />);
						break;
					case 'distant':
						data = orders
							.filter((order) => order.status === filterOrderNav)
							.sort(
								(a, b) =>
									Date.parse(b.dateOfDelivery) - Date.parse(a.dateOfDelivery)
							)
							.map((order) => <ListItem key={order.id} order={order} />);
						break;
					case 'recents':
						data = orders
							.filter((order) => order.status === filterOrderNav)
							.sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
							.map((order) => <ListItem key={order.id} order={order} />);
						break;
					case 'oldest':
						data = orders
							.filter((order) => order.status === filterOrderNav)
							.sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt))
							.map((order) => <ListItem key={order.id} order={order} />);
						break;

					default:
						data = orders
							.filter((order) => order.status === filterOrderNav)
							.map((order) => <ListItem key={order.id} order={order} />);

						break;
				}
				break;
		}
		return data;
	};

	return (
		<Box sx={{ marginBottom: '64px' }}>
			<List className='dawd' disablePadding>
				{orders.length === 0 ? (
					<Box
						sx={{
							width: '100%',
							display: 'flex',
							justifyContent: 'center',
						}}
					>
						No hay pedidos
					</Box>
				) : (
					<FilteredData />
				)}
			</List>
			<NewOrderDialog />
			<ToastAlert />
			<Paper
				sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}
				elevation={3}
			>
				<BottomNavigation value={filterOrderNav}>
					<BottomNavigationAction
						label='Todos'
						value='all'
						icon={<Reorder />}
						onClick={() => {
							onChangeFilterOrderNav('all');
						}}
					/>
					<BottomNavigationAction
						label='Pendientes'
						value='pending'
						icon={<Pending />}
						onClick={() => {
							onChangeFilterOrderNav('pending');
						}}
					/>
					<BottomNavigationAction
						label='En Proceso'
						value='inProgress'
						icon={<Timelapse />}
						onClick={() => {
							onChangeFilterOrderNav('inProgress');
						}}
					/>
					<BottomNavigationAction
						label='Terminados'
						value='done'
						icon={<CheckCircle />}
						onClick={() => {
							onChangeFilterOrderNav('done');
						}}
					/>
				</BottomNavigation>
			</Paper>
		</Box>
	);
}
